module.exports = __webpack_public_path__ + "img/gonAn.58f55c5c.png";